import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaChevronRight,
    FaSearch
} from 'react-icons/fa';

const EngineerInterGovernanceWorksByDate = () => {
    const navigate = useNavigate();
    const [lotteryDate, setLotteryDate] = useState('');
    const [department, setDepartment] = useState('');
    const [taluka, setTaluka] = useState('');

    // Marathi numerals for Sr.No.
    const marathiNumerals = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    const toMarathiNumber = (n) => String(n).split('').map(digit => marathiNumerals[parseInt(digit)] || digit).join('');

    const talukas = [
        "मिरज", "जत", "खानापूर (विटा)", "वाळवा (इस्लामपूर)", "तासगाव", 
        "शिराळा", "कडेगाव", "पलूस", "कवठे महांकाळ"
    ];

    const departments = ["समाज", "सु. बे."];

    // Simulated data
    const [data] = useState([]);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-marathi">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10 px-2 text-left">
                    <div className="flex items-center gap-6">
                        <button 
                            onClick={() => navigate('/engineer/inter-governance-menu')}
                            className="p-4 bg-white rounded-2xl shadow-sm hover:bg-gray-50 transition-all text-gray-600 border border-gray-100 hover:scale-105 active:scale-95 group"
                        >
                            <FaArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-2xl font-black text-gray-800 tracking-tight tracking-tight">जिल्हा इंटरेस्टेड कामांची यादी (तारखेनुसार)</h1>
                    </div>
                    <div className="hidden md:flex items-center gap-3 text-[11px] font-black text-gray-400 bg-white px-6 py-3 rounded-2xl border border-gray-100 shadow-sm uppercase tracking-wider">
                        जिल्हा परिषद <FaChevronRight size={10} className="text-gray-200" /> <span className="text-teal-600">तारखेनुसार यादी</span>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 p-8 mb-8">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-end">
                        <div className="space-y-2">
                            <label className="text-[13px] font-black text-gray-500 uppercase tracking-tight">लॉटरीची तारीख निवडा <span className="text-red-500">*</span></label>
                            <input 
                                type="date"
                                className="w-full border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-teal-500 bg-gray-50/50 text-gray-700 font-bold transition-all"
                                value={lotteryDate}
                                onChange={(e) => setLotteryDate(e.target.value)}
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-[13px] font-black text-gray-500 uppercase tracking-tight">विभाग</label>
                            <select 
                                className="w-full border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-teal-500 bg-gray-50/50 text-gray-700 font-bold transition-all"
                                value={department}
                                onChange={(e) => setDepartment(e.target.value)}
                            >
                                <option value="">विभाग निवड</option>
                                {departments.map((d, idx) => (
                                    <option key={idx} value={d}>{d}</option>
                                ))}
                            </select>
                        </div>
                        <div className="space-y-2">
                            <label className="text-[13px] font-black text-gray-500 uppercase tracking-tight">तालुका निवडा</label>
                            <select 
                                className="w-full border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-teal-500 bg-gray-50/50 text-gray-700 font-bold transition-all"
                                value={taluka}
                                onChange={(e) => setTaluka(e.target.value)}
                            >
                                <option value="">तालुका निवडा</option>
                                {talukas.map((t, idx) => (
                                    <option key={idx} value={t}>{t}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-3 rounded-xl font-bold shadow-lg shadow-blue-500/20 transition transform active:scale-95 flex items-center justify-center gap-2 w-full md:w-auto">
                                <FaSearch size={14} />
                                शोध
                            </button>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="mt-10 overflow-hidden border border-gray-100 rounded-[1.5rem] shadow-sm">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 text-[13px] font-black text-gray-800 text-left uppercase">
                                    <th className="px-8 py-6 border-r border-gray-100 w-24">#</th>
                                    <th className="px-8 py-6 border-r border-gray-100 min-w-[180px]">कामाचा आयडी</th>
                                    <th className="px-8 py-6 border-r border-gray-100 min-w-[350px]">कामाचे नाव</th>
                                    <th className="px-8 py-6 border-r border-gray-100 min-w-[200px]">निवेदा रक्कम</th>
                                    <th className="px-8 py-6 min-w-[200px]">इंटरेस्टेड काउंट</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="px-8 py-10 text-center text-gray-500 font-bold bg-[#f8fafc]/50">
                                            यादी सापडली नाही.
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, index) => (
                                        <tr key={index} className="hover:bg-blue-50/20 group transition-colors border-b border-gray-100 last:border-0 text-[14px] text-gray-700 font-bold">
                                            <td className="px-8 py-7 border-r border-gray-100 text-gray-400">{toMarathiNumber(index + 1)}</td>
                                            <td className="px-8 py-7 border-r border-gray-100">{item.workId}</td>
                                            <td className="px-8 py-7 border-r border-gray-100 font-marathi leading-relaxed">{item.name}</td>
                                            <td className="px-8 py-7 border-r border-gray-100 font-marathi">{toMarathiNumber(item.amount)}</td>
                                            <td className="px-8 py-7 font-marathi">{toMarathiNumber(item.count)} - इंटरेस्टेड ॲप्लिकेशन पहा</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerInterGovernanceWorksByDate;
